import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

const CareerApplicationList = () => {
    const [listOfApplications, setListOfApplications] = useState([]);
    const [currentId, setCurrentId] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(
            "https://manncarriers.com/server/careerGetAll.php"
            //"http://localhost:8080/mann/careerGetAll.php"
        ).then((response) => {
            setListOfApplications(response.data.data);
            // console.log(response.data.data);
        });
    }, []);

    const deleteApplication = () => {
        axios.delete(
            //`http://localhost:8080/mann/careerDelete.php?id=${currentId}`
            `https://manncarriers.com/server/careerDelete.php?id=${currentId}`
        ).then(() => {
            setListOfApplications(listOfApplications.filter(item => item.id !== currentId));
        }).then(() => {
            hideDeleteModal();
        });
    };

    const showDeleteModal = (id) => {
        document.getElementById("deleteModal").style.display = "block";
        setCurrentId(id);
    };

    const hideDeleteModal = () => {
        document.getElementById("deleteModal").style.display = "none";
    };

    return (
        <div className='w-100'>
            <div className="modal" id="deleteModal">
                <div className="modal-dialog shadow-box" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="btn-close" onClick={hideDeleteModal}></button>
                        </div>
                        <div className="modal-body text-dark">
                            <p>Are you sure you want to delete this application?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger mx-3" onClick={deleteApplication}>Yes</button>
                            <button type="button" className="btn btn-primary" onClick={hideDeleteModal}>No</button>
                        </div>
                    </div>
                </div>
            </div>

            <h2>Career Applications</h2>

            <table className="table">

                <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Date of Birth</th>
                    <th>Experience</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th></th>
                </tr>

                {listOfApplications?.map((app, index) => {
                    const formattedDate = new Date(app.datetime).toLocaleDateString('en-CA', {
                        day: 'numeric', month: 'long', year: 'numeric'
                    });
                    return (
                        <tr key={index}>
                            <td>{app.applicationtype}</td>
                            <td>{`${app.firstname} ${app.middlename} ${app.lastname}`}</td>
                            <td>{app.phone}</td>
                            <td>{app.dbo}</td>
                            <td>{app.experience}</td>
                            <td>{app.email}</td>
                            <td>{formattedDate}</td>
                            <td>
                                <div className='text-primary d-inline onHover' onClick={() => navigate(`/careerdetail/${app.id}`)}>Detail</div>
                                <div className='text-danger d-inline onHover' onClick={() => showDeleteModal(app.id)}>Delete</div>
                            </td>
                        </tr>
                    );
                })}

            </table>
        </div>
    );
};

export default CareerApplicationList;
